module.exports = __webpack_public_path__ + "static/img/smaco-9.a98ecfa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg/smaco-9.jpg
// module id = 86t2
// module chunks = 1